import Footer from "../components/layout/Footer.tsx";
import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "../components/layout/Header.tsx";

const ScrollToTop: React.FC = () => {
  // hooks
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

const MainLayout: React.FC = () => {
  // renders
  return (
    <div className="w-full min-h-screen overflow-x-hidden flex flex-col items-center">
      <ScrollToTop />
      <Header />
      <div className="w-full flex flex-col items-center pt-12 lg:pt-24">
        <Outlet />
      </div>
      <Footer />
    </div>
  );
};

export default MainLayout;
